import addInfoBarMessage from 'owa-info-bar/lib/actions/addInfoBarMessage';
import createInfoBarMessageViewStateFactory from '../utils/createInfoBarMessageViewStateFactory';
import removeInfoBarMessage from 'owa-info-bar/lib/actions/removeInfoBarMessage';
import type { InfoBarHostViewState } from 'owa-info-bar/lib/schema/InfoBarMessageViewState';

/**
 * @param eventId This parameter is no longer used. We keep it here just for compatibility
 */
export const addNotificationMessage = (
    hostItemIndex: string,
    viewState: InfoBarHostViewState,
    eventId?: string
) => (messageId: string) => {
    const creator = createInfoBarMessageViewStateFactory(
        hostItemIndex,
        messageId,
        removeNotificationMessage(viewState)
    );
    addInfoBarMessage(viewState, messageId, creator);
};

/**
 * @param eventId This parameter is no longer used. We keep it here just for compatibility
 */
export const removeNotificationMessage = (viewState: InfoBarHostViewState, eventId?: string) => (
    messageId: string
) => {
    removeInfoBarMessage(viewState, messageId);
};

export const getNotificationMessageIds = (viewState: InfoBarHostViewState) => (): string[] => {
    return viewState.infoBarIds;
};
